import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-terminos-condiciones',
  templateUrl: './modal-terminos-condiciones.component.html',
  styleUrls: ['./modal-terminos-condiciones.component.scss']
})
export class ModalTerminosCondicionesComponent implements OnInit {

  @Input() isVisible: boolean = false;
  @Output() onClose = new EventEmitter<boolean>();
  @Output() onAccept = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  cerrarModal(): void {
    this.isVisible = false;
    this.onClose.emit(false);
  }

  aceptarTerminos(): void {
    this.isVisible = false;
    this.onAccept.emit();
  }

}
